export function isValidZipCode(zipCode: string): boolean {
  const regex = /^\d{5}-\d{3}$/;

  return regex.test(zipCode);
}
